import React, { createContext, useContext } from 'react';
import { defaultAuthContext } from './default-auth-context';
import { useAuthProvider } from '../hooks/useAuthProvider';
export var AuthContext = /*#__PURE__*/ createContext(defaultAuthContext);
export var AuthProvider = function(param) {
    var children = param.children, config = param.config, ideMessagingService = param.ideMessagingService, navigationService = param.navigationService, injectedTokenManager = param.tokenManager;
    var contextValue = useAuthProvider({
        config: config,
        ideMessagingService: ideMessagingService,
        navigationService: navigationService,
        tokenManager: injectedTokenManager
    });
    return /*#__PURE__*/ React.createElement(AuthContext.Provider, {
        value: contextValue
    }, children);
};
export var useAuth = function() {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
// 기본 exports
export { TOKEN_KEY, USER_KEY, REFRESH_TOKEN_KEY, ID_TOKEN_KEY } from './types';
